"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const init = () => {
    let elements = [];
    const toggleDropdownElements = (dropdowns = []) => dropdowns.forEach((e) => e.classList.toggle('is-open'));
    const toggleDropdowns = (dropdowns = []) => {
        toggleDropdownElements([...elements, ...dropdowns]);
        elements = [...dropdowns];
    };
    const dropdowns = [...document.querySelectorAll('.js-dropdown')].map((dropdown) => {
        [...dropdown.querySelectorAll('.js-dropdown-button')].forEach((btn) => {
            btn.addEventListener('click', () => {
                var _a;
                const isOpen = [...((_a = dropdown === null || dropdown === void 0 ? void 0 : dropdown.classList) !== null && _a !== void 0 ? _a : [])].includes('is-open');
                toggleDropdowns(!isOpen ? [dropdown] : []);
            });
        });
        return dropdown;
    });
    if (dropdowns.length > 0) {
        document.addEventListener('click', (e) => {
            const el = e.target;
            if (!(el === null || el === void 0 ? void 0 : el.closest('.js-dropdown'))) {
                toggleDropdowns([]);
            }
        }, false);
    }
};
exports.default = (() => {
    addEventListener('DOMContentLoaded', init);
})();
